export type Modifiers = Partial<Record<string, boolean>>;

export interface TrackTrigger {
  shouldFire(click: MouseEvent, element: Element): boolean;
}

/* Always fires when the element is clicked. */
class ClickTrigger implements TrackTrigger {
  shouldFire(): boolean {
    return true;
  }
}

/* Fires only if the click opens something. */
class OpenTrigger implements TrackTrigger {
  shouldFire(click: MouseEvent, element: Element): boolean {
    const target = click.target instanceof Element ? click.target : null;
    const toggle = target?.closest('[aria-expanded]');

    return (
      !!toggle &&
      element.contains(toggle) &&
      toggle.getAttribute('aria-expanded') !== 'true'
    );
  }
}

const DEFAULT_TRIGGER: TrackTrigger = new ClickTrigger();
const TRIGGERS_BY_MODIFIER: ReadonlyMap<string, TrackTrigger> = new Map([
  ['open', new OpenTrigger()],
]);

export function resolveTrigger(modifiers: Modifiers): TrackTrigger {
  const modifier = Object.keys(modifiers).find(
    key => modifiers[key] && TRIGGERS_BY_MODIFIER.has(key),
  );

  return (modifier && TRIGGERS_BY_MODIFIER.get(modifier)) || DEFAULT_TRIGGER;
}
